var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{staticClass:"ml-1",attrs:{"title":_vm.title,"data-panel-id":_vm.panelView.id,"active":_vm.isSelected},on:{"click":_vm.onClick}},[_c('span',{class:['fa', `fa-${_vm.icon}`],attrs:{"fixed-width":""}}),_vm._v(" "),_c('span',{directives:[{name:"localize",rawName:"v-localize"}]},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }